<template>
    <v-dialog
        max-width="800px"
        v-model="isOpenComercialFilterDialog"
        persistent
    >
        <v-form>
            <v-card>
                <v-card-title primary-title>
                    <div
                        v-if="$vuetify.breakpoint.xs"
                        class="primary--text text-overline ml-2"
                    >
                        <v-icon left> mdi-magnify </v-icon>
                        Filtros de búsqueda
                    </div>
                    <div
                        v-else
                        class="font-weight-light primary--text text-h4 ml-2"
                    >
                        <v-icon large left> mdi-magnify </v-icon>
                        Filtros de búsqueda
                    </div>
                </v-card-title>
                <!-- <v-divider class="test"></v-divider> -->

                <v-card-text>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-card elevation="0" class="px-4">
                                <!-- <v-row>
                                    <v-col md="12" class="mt-md-1">
                                        <h4
                                            class="
                                                font-weight-light
                                                primary--text
                                            "
                                        >
                                            Tipo de comercial
                                        </h4>
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider> -->
                                <v-row>
                                    <v-col cols="12">
                                        <v-combobox
                                            :class="
                                                filtersComercial.tipoComercial
                                                    ? 'mt-2'
                                                    : 'mt-2 mb-2'
                                            "
                                            v-model="
                                                filtersComercial.tipoComercial
                                            "
                                            :items="tipoComercial"
                                            item-text="human"
                                            item-value="encoded"
                                            :return-object="false"
                                            clearable
                                            label="Tipo de comercial"
                                            prepend-icon="mdi-account-convert"
                                        >
                                            <template
                                                v-slot:selection="{ item }"
                                            >
                                                <v-chip
                                                    color="orange accent-3"
                                                    dark
                                                >
                                                    {{
                                                        item
                                                            .toLowerCase()
                                                            .replace(
                                                                /\w/,
                                                                (firstLetter) =>
                                                                    firstLetter.toUpperCase()
                                                            )
                                                    }}
                                                </v-chip>
                                            </template>
                                        </v-combobox>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-card elevation="0" class="px-4">
                                <!-- <v-row>
                                    <v-col md="12" class="mt-md-1">
                                        <h4
                                            class="
                                                font-weight-light
                                                primary--text
                                            "
                                        >
                                            Estado comercial
                                        </h4>
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider> -->
                                <v-row>
                                    <v-col cols="12">
                                        <v-combobox
                                            :class="
                                                filtersComercial.estado
                                                    ? 'mt-2'
                                                    : 'mt-2 mb-2'
                                            "
                                            v-model="filtersComercial.estado"
                                            :items="estadoComercial"
                                            item-text="human"
                                            item-value="encoded"
                                            :return-object="false"
                                            clearable
                                            label="Estado comercial"
                                            prepend-icon="mdi-account-convert"
                                        >
                                            <template
                                                v-slot:selection="{ item }"
                                            >
                                                <v-chip
                                                    color="orange accent-3"
                                                    dark
                                                >
                                                    {{
                                                        item
                                                            .toLowerCase()
                                                            .replace(
                                                                /\w/,
                                                                (firstLetter) =>
                                                                    firstLetter.toUpperCase()
                                                            )
                                                    }}
                                                </v-chip>
                                            </template>
                                        </v-combobox>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="justify-end">
                    <v-btn @click="submit()" depressed color="success" dark>
                        Filtrar
                    </v-btn>
                    <v-btn
                        @click="isOpenComercialFilterDialog = false"
                        text
                        color="red"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
export default {
    name: 'ComercialesTableFilterDialog',
    data: () => ({
        filtersComercial: {
            tipoComercial: null,
            estado: null,
        },
    }),
    methods: {
        submit() {
            this.$emit('filterEvent', this.filtersComercial);
            this.isOpenComercialFilterDialog = false;
        },
    },
    computed: {
        tipoComercial() {
            return JSON.parse(localStorage.getItem('opciones'))?.cuenta
                .tipoComercial;
        },
        estadoComercial() {
            return JSON.parse(localStorage.getItem('opciones'))?.cuenta.estado;
        },
        isOpenComercialFilterDialog: {
            get() {
                return this.$store.state.reportTable
                    .isOpenComercialFilterDialog;
            },
            set(val) {
                this.$store.commit(
                    'reportTable/isOpenComercialFilterDialog',
                    val
                );
            },
        },
    },
};
</script>
